'use client'
import React from 'react'
import styles from './styles.module.scss'

const FirstLeader: React.FC = () => {
  return (
    <div className={styles.leaderIcon}>
      <svg
        width="35"
        height="22"
        viewBox="0 0 35 22"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M26.3242 21.1304C26.3905 21.0686 32.8757 14.8587 30.1175 4.85787C30.0988 4.78946 30.1382 4.71844 30.2066 4.6992C30.3168 4.66809 30.4311 4.73293 30.461 4.84338C33.2222 15.0022 26.6211 21.313 26.5532 21.3755L26.3242 21.1304Z" />
        <path d="M33.4241 15.378C32.536 18.139 29.9453 17.4773 29.9453 17.4773C30.6828 14.7735 33.4241 15.378 33.4241 15.378Z" />
        <path d="M31.1016 14.2219C34.392 14.5813 34.4488 11.5751 34.4488 11.5751C31.2904 11.5176 31.1016 14.2219 31.1016 14.2219Z" />
        <path d="M34.4649 7.32898C34.1193 11.1232 31.522 10.7216 31.522 10.7216C31.3098 7.18266 34.4649 7.32898 34.4649 7.32898Z" />
        <path d="M32.7188 1.88672C34.4397 5.53561 31.5108 6.82087 31.5108 6.82087C30.1702 3.6076 32.7188 1.88672 32.7188 1.88672Z" />
        <path d="M29.0139 0C31.8495 1.53134 30.1678 4.35814 30.1678 4.35814C27.123 1.73988 29.0139 0 29.0139 0Z" />
        <path d="M26.3041 13.6406C29.4523 14.3537 28.8882 17.0774 28.8882 17.0774C25.5469 16.4475 26.3041 13.6402 26.3041 13.6406Z" />
        <path d="M27.0258 10.0352C30.0697 10.9425 29.8618 13.7598 29.8618 13.7598C26.8367 13.8356 27.0258 10.0352 27.0258 10.0352Z" />
        <path d="M27.1562 7.09375C30.3325 7.22558 30.2569 10.4778 30.2569 10.4778C28.2147 10.8179 27.1562 7.09375 27.1562 7.09375Z" />
        <path d="M27.1602 3.78125C30.0528 4.25417 29.958 6.79 29.958 6.79C27.1974 6.60426 27.1602 3.78125 27.1602 3.78125Z" />
        <path d="M8.14453 21.6108C8.07826 21.5491 1.59306 15.3392 4.35122 5.33834C4.36999 5.26993 4.33056 5.19891 4.26215 5.17967C4.15194 5.14856 4.03769 5.2134 4.00776 5.32385C1.24651 15.4826 7.84762 21.7935 7.91556 21.856L8.14453 21.6108Z" />
        <path d="M1.0329 15.8624C1.92101 18.6234 4.51172 17.9617 4.51172 17.9617C3.7742 15.2579 1.0329 15.8624 1.0329 15.8624Z" />
        <path d="M3.36328 14.718C0.0728202 15.0774 0.0160515 12.0712 0.0160515 12.0712C3.17445 12.0137 3.36328 14.718 3.36328 14.718Z" />
        <path d="M-7.00951e-05 7.80945C0.345532 11.6037 2.94289 11.202 2.94289 11.202C3.155 7.66313 -7.00951e-05 7.80945 -7.00951e-05 7.80945Z" />
        <path d="M1.74601 2.375C0.0251305 6.02389 2.95408 7.30915 2.95408 7.30915C4.29468 4.09588 1.74601 2.375 1.74601 2.375Z" />
        <path d="M5.44311 0.476562C2.60751 2.0079 4.28921 4.83471 4.28921 4.83471C7.33406 2.21645 5.44311 0.476562 5.44311 0.476562Z" />
        <path d="M8.15681 14.125C5.00862 14.8381 5.57275 17.5618 5.57275 17.5618C8.91404 16.9319 8.15681 14.1245 8.15681 14.125Z" />
        <path d="M7.43517 10.5195C4.39126 11.4269 4.59909 14.2442 4.59909 14.2442C7.62424 14.32 7.43517 10.5195 7.43517 10.5195Z" />
        <path d="M7.30078 7.57422C4.12457 7.70605 4.2001 10.9583 4.2001 10.9583C6.24236 11.2984 7.30078 7.57422 7.30078 7.57422Z" />
        <path d="M7.30078 4.25781C4.40818 4.73073 4.50295 7.26657 4.50295 7.26657C7.26349 7.08082 7.30078 4.25781 7.30078 4.25781Z" />
      </svg>
    </div>
  )
}

export default FirstLeader
